namespace Nobox {

    //@Serenity.Decorators.registerFormatter()
    //export class CurrencyFormatter implements Slick.Formatter {

    //    @Serenity.Decorators.option()
    //    public cultureName: string;
    //    @Serenity.Decorators.option()
    //    public currencyName: string;

    //    format(ctx: Slick.FormatterContext) {

    //        //If the input is not a float - just bounce it back
    //        if (isNaN(parseFloat(ctx.value))) {
    //            return ctx.value;
    //        }

    //        //Use standard currency formatting; This can be modified for other styles (% etc).
    //        //If no parameters passed then fallback to en-US , USD formatting.
    //        this.cultureName = this.cultureName ? this.cultureName : 'en-US';
    //        this.currencyName = this.currencyName ? this.currencyName : 'USD';

    //        var formatter = new Intl.NumberFormat(this.cultureName, {
    //            style: 'currency',
    //            currency: this.currencyName,
    //            minimumFractionDigits: 2,
    //        });

    //        //use the above formatter to return the reformatted value
    //        var percentValue = formatter.format(Number(ctx.value));
    //        return "<span>" + percentValue + '</span>';
    //    }



    //}

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class CurrencyFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            var value = "0";
            var input = $(`<input type="text">`);

            var optionAuto = $.cookie("formatnumber");
            if (optionAuto == undefined) {
                input.autoNumeric('init');
            } else {
                var formatnumber = JSON.parse(decodeURIComponent(optionAuto));
                if (jQuery.isEmptyObject(formatnumber)) {
                } else {
                    var obj = {};
                    if ('aDec' in formatnumber) {
                        obj["aDec"] = formatnumber["aDec"];
                    }
                    if ('mDec' in formatnumber) {
                        obj["mDec"] = formatnumber["mDec"];
                    }
                    if ('aSep' in formatnumber) {
                        obj["aSep"] = formatnumber["aSep"];
                    }
                    if ('dGroup' in formatnumber) {
                        obj["dGroup"] = formatnumber["dGroup"];
                    }
                    if ('lZero' in formatnumber) {
                        obj["lZero"] = formatnumber["lZero"];
                    }
                    input.autoNumeric('init', obj);
                }
            }
            if (ctx.value == "" || ctx.value == null) {
                value = "0";
            } else {
                input.autoNumeric('set', ctx.value);
                value = input.val();
            }
            var currencies = $.cookie("currencies");
            var currenciesPlace = $.cookie("currenciesplace");
            if (currencies == undefined) {
                currencies = "Rp";
            }
            if (currenciesPlace == undefined) {
                return `${currencies} ${value}`;
            } else {
                if (currenciesPlace == "right") {
                    return `${value} ${currencies}`;
                } else {
                    return `${currencies} ${value}`;
                }
            }
        }

        @Serenity.Decorators.option()
        public contractAmount: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.contractAmount)
                column.referencedFields.push(this.contractAmount);
        }
    }
}